import { ChatMessageProps } from './types';

export const ChatMessage = ({ testId, ownMessage, children }: ChatMessageProps) => (
    <div data-testid={testId} className={`relative flex items-start ${ownMessage ? ' flex-row-reverse' : ' flex-row'} px-6 py-1.5`}>
        {children}
    </div>
);
